import React, { useEffect, useState } from "react";

const handlePlayStoreClick = () => {
  window.location.href = "https://play.google.com/store/apps/details?id=com.vondijital.temelden_app";
};

const handleAppStoreClick = () => {
  window.location.href = "https://apps.apple.com/tr/app/temelden/id6758143279";
};

const Yatirim = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const styles = {
    page: {
      backgroundColor: "#f7f7f7",
      minHeight: "100vh",
      padding: isMobile ? "30px 15px" : "60px 20px",
      display: "flex",
      justifyContent: "center",
    },
    container: {
      maxWidth: "1000px",
      backgroundColor: "#fff",
      borderRadius: "12px",
      padding: isMobile ? "25px 20px" : "40px 30px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
      lineHeight: "1.7",
      width: "100%",
    },
    title: {
      fontSize: isMobile ? "20px" : "26px",
      fontWeight: "700",
      textAlign: "center",
      marginBottom: "30px",
      color: "#222",
    },
    section: {
      marginBottom: "35px",
    },
    sectionHeader: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: isMobile ? "flex-start" : "center",
      marginBottom: "15px",
      gap: "8px",
    },
    heading: {
      fontSize: isMobile ? "16px" : "18px",
      fontWeight: "600",
      color: "#333",
      borderBottom: "2px solid #f0f0f0",
      paddingBottom: "8px",
      flex: 1,
    },
    viewAllLink: {
      fontSize: "14px",
      color: "#001E78",
      textDecoration: "none",
      fontWeight: "500",
      marginLeft: isMobile ? "0" : "15px",
      ":hover": {
        textDecoration: "underline",
      },
    },
    text: {
      fontSize: "14px",
      color: "#555",
      marginBottom: "10px",
      lineHeight: "1.6",
    },
    cardsGrid: {
      display: "grid",
      gridTemplateColumns: isMobile
        ? "1fr"
        : "repeat(auto-fit, minmax(250px, 1fr))",
      gap: "20px",
      marginTop: "15px",
    },
    card: {
      backgroundColor: "#f8f9fa",
      padding: "20px",
      borderRadius: "8px",
      border: "1px solid #e9ecef",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
    },
    cardTitle: {
      fontSize: "16px",
      fontWeight: "600",
      color: "#001E78",
      marginBottom: "10px",
    },
    cardText: {
      fontSize: "14px",
      color: "#555",
      lineHeight: "1.5",
    },
    warningBox: {
      backgroundColor: "#fff8e1",
      padding: "25px",
      borderRadius: "8px",
      border: "1px solid #ffd54f",
    },
    warningTitle: {
      fontSize: "16px",
      fontWeight: "600",
      color: "#d32f2f",
      marginBottom: "15px",
    },
    warningList: {
      paddingLeft: "20px",
      margin: 0,
    },
    warningItem: {
      fontSize: "14px",
      color: "#555",
      marginBottom: "10px",
      lineHeight: "1.5",
    },
    analysisGrid: {
      display: "grid",
      gridTemplateColumns: isMobile
        ? "1fr"
        : "repeat(auto-fit, minmax(200px, 1fr))",
      gap: "15px",
      marginTop: "20px",
    },
    analysisItem: {
      backgroundColor: "#f8f9fa",
      padding: "15px",
      borderRadius: "6px",
      border: "1px solid #e9ecef",
    },
    analysisTitle: {
      fontSize: "14px",
      fontWeight: "600",
      color: "#001E78",
      marginBottom: "8px",
    },
    analysisText: {
      fontSize: "13px",
      color: "#555",
      lineHeight: "1.4",
    },
    aiSection: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      gap: "30px",
      alignItems: "center",
      backgroundColor: "#f0f7ff",
      padding: "25px",
      borderRadius: "8px",
      border: "1px solid #cfe2ff",
    },
    aiContent: {
      flex: 2,
    },
    aiTitle: {
      fontSize: "16px",
      fontWeight: "600",
      color: "#001E78",
      marginBottom: "10px",
    },
    aiText: {
      fontSize: "14px",
      color: "#555",
      marginBottom: "15px",
      lineHeight: "1.6",
    },
    aiFeatures: {
      paddingLeft: "20px",
      margin: 0,
    },
    aiFeature: {
      fontSize: "14px",
      color: "#555",
      marginBottom: "8px",
      lineHeight: "1.5",
    },
    aiVisual: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      width: "100%",
    },
    aiPlaceholder: {
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "8px",
      border: "2px dashed #cfe2ff",
      textAlign: "center",
      minWidth: isMobile ? "100%" : "150px",
    },
    aiPlaceholderText: {
      fontSize: "14px",
      fontWeight: "600",
      color: "#001E78",
      marginBottom: "5px",
    },
    aiPlaceholderSubtext: {
      fontSize: "12px",
      color: "#666",
    },
    appFeatures: {
      display: "grid",
      gridTemplateColumns: isMobile
        ? "1fr"
        : "repeat(auto-fit, minmax(200px, 1fr))",
      gap: "15px",
      marginTop: "15px",
    },
    appFeature: {
      backgroundColor: "#f8f9fa",
      padding: "15px",
      borderRadius: "6px",
      border: "1px solid #e9ecef",
      textAlign: "center",
    },
    appFeatureTitle: {
      fontSize: "14px",
      fontWeight: "600",
      color: "#001E78",
      marginBottom: "8px",
    },
    appFeatureText: {
      fontSize: "13px",
      color: "#555",
      lineHeight: "1.4",
    },
    articlesSection: {
      backgroundColor: "#f8f9fa",
      padding: "25px",
      borderRadius: "8px",
      border: "1px solid #e9ecef",
    },
    articlesGrid: {
      display: "grid",
      gridTemplateColumns: isMobile
        ? "1fr"
        : "repeat(auto-fit, minmax(250px, 1fr))",
      gap: "20px",
      margin: "20px 0",
    },
    articleCard: {
      backgroundColor: "white",
      padding: "20px",
      borderRadius: "6px",
      border: "1px solid #dee2e6",
    },
    articleTitle: {
      fontSize: "15px",
      fontWeight: "600",
      color: "#001E78",
      marginBottom: "10px",
    },
    articleText: {
      fontSize: "14px",
      color: "#555",
      marginBottom: "15px",
      lineHeight: "1.5",
    },
    readMoreLink: {
      fontSize: "14px",
      color: "#001E78",
      textDecoration: "none",
      fontWeight: "500",
      ":hover": {
        textDecoration: "underline",
      },
    },
    articlesCTA: {
      textAlign: "center",
      marginTop: "20px",
    },
    articlesButton: {
      backgroundColor: "#001E78",
      color: "white",
      padding: "12px 24px",
      borderRadius: "6px",
      textDecoration: "none",
      fontSize: "14px",
      fontWeight: "600",
      display: "inline-block",
      transition: "background-color 0.3s ease",
    },
    faqGrid: {
      display: "grid",
      gridTemplateColumns: isMobile
        ? "1fr"
        : "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "20px",
    },
    faqItem: {
      backgroundColor: "#f8f9fa",
      padding: "20px",
      borderRadius: "6px",
      border: "1px solid #e9ecef",
    },
    faqQuestion: {
      fontSize: "15px",
      fontWeight: "600",
      color: "#001E78",
      marginBottom: "10px",
    },
    faqAnswer: {
      fontSize: "14px",
      color: "#555",
      lineHeight: "1.5",
    },
    ctaSection: {
      backgroundColor: "#001E78",
      padding: isMobile ? "25px 15px" : "30px",
      borderRadius: "8px",
      textAlign: "center",
      marginBottom: "25px",
    },
    ctaTitle: {
      fontSize: isMobile ? "18px" : "20px",
      fontWeight: "600",
      color: "white",
      marginBottom: "10px",
    },
    ctaText: {
      fontSize: "14px",
      color: "white",
      marginBottom: "20px",
      lineHeight: "1.6",
    },
    ctaButtons: {
      display: "flex",
      gap: "15px",
      justifyContent: "center",
      flexWrap: "wrap",
    },
    ctaButton: {
      backgroundColor: "white",
      color: "#001E78",
      padding: "12px 20px",
      border: "none",
      borderRadius: "6px",
      fontSize: "14px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
      minWidth: "160px",
    },
    disclaimer: {
      backgroundColor: "#f8f9fa",
      padding: "15px",
      borderRadius: "6px",
      border: "1px solid #e9ecef",
      textAlign: "center",
    },
    disclaimerText: {
      fontSize: "12px",
      color: "#666",
      margin: 0,
      fontStyle: "italic",
    },
  };

return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>TEMELDEN YATIRIM</h1>
        
        <section style={styles.section}>
          <h2 style={styles.heading}>Akıllı Yatırım Çözümleri</h2>
          <p style={styles.text}>
            Temelden platformu olarak, gayrimenkul yatırımlarınızda size en doğru ve kazançlı 
            kararları almanız için profesyonel danışmanlık hizmeti sunuyoruz. Gelişmiş analiz 
            araçlarımız ve yapay zeka destekli sistemimiz ile yatırım risklerinizi minimize 
            edin, getirilerinizi maksimize edin.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Yatırım Tavsiyeleri</h2>
          <div style={styles.cardsGrid}>
            <div style={styles.card}>
              <h3 style={styles.cardTitle}>Lokasyon Analizi</h3>
              <p style={styles.cardText}>
                Doğru lokasyon seçimi yatırım başarınızı direkt etkiler. Gelişmekte olan 
                bölgeleri ve altyapı yatırımlarını takip edin.
              </p>
            </div>

            <div style={styles.card}>
              <h3 style={styles.cardTitle}>Piyasa Trendleri</h3>
              <p style={styles.cardText}>
                Gayrimenkul piyasası dinamiklerini anlayın. Talep-artış bölgelerini 
                ve gelecek vaadeden projeleri önceliklendirin.
              </p>
            </div>

            <div style={styles.card}>
              <h3 style={styles.cardTitle}>Risk Yönetimi</h3>
              <p style={styles.cardText}>
                Yatırım portföyünüzü çeşitlendirin. Farklı bölge ve proje türlerine 
                yatırım yaparak risklerinizi dağıtın.
              </p>
            </div>
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Dikkat Edilmesi Gereken Hususlar</h2>
          <div style={styles.warningBox}>
            <h3 style={styles.warningTitle}>Yatırım Öncesi Kontrol Listesi</h3>
            <ul style={styles.warningList}>
              <li style={styles.warningItem}>
                <strong>Tapu ve İmar Durumu:</strong> Tapunun temiz olması ve imar planlarına uygunluğu
              </li>
              <li style={styles.warningItem}>
                <strong>İnşaat Kalitesi:</strong> Kullanılan malzeme kalitesi ve işçilik standartları
              </li>
              <li style={styles.warningItem}>
                <strong>Developer Güvenilirliği:</strong> Şirketin referansları ve geçmiş projeleri
              </li>
              <li style={styles.warningItem}>
                <strong>Finansal Planlama:</strong> Nakit akışı ve finansman alternatiflerinin değerlendirilmesi
              </li>
              <li style={styles.warningItem}>
                <strong>Hukuki Süreçler:</strong> Sözleşme detayları ve yasal yükümlülükler
              </li>
              <li style={styles.warningItem}>
                <strong>Pazar Araştırması:</strong> Bölgedeki arz-talep dengesi ve kiralama potansiyeli
              </li>
            </ul>
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Bölgesel Getiri Analizleri</h2>
          <p style={styles.text}>
            Mobil uygulamamız üzerinden şehir ve ilçe bazlı detaylı getiri analizlerine 
            ulaşabilir, yapay zeka destekli öneriler alabilirsiniz.
          </p>
          <div style={styles.analysisGrid}>
            <div style={styles.analysisItem}>
              <h4 style={styles.analysisTitle}>İstanbul Getiri Oranları</h4>
              <p style={styles.analysisText}>
                Yıllık ortalama: %8-12<br />
                En yüksek getiri: Gelişen ilçeler
              </p>
            </div>
            <div style={styles.analysisItem}>
              <h4 style={styles.analysisTitle}>Ankara Yatırım Fırsatları</h4>
              <p style={styles.analysisText}>
                Yıllık ortalama: %6-9<br />
                Öne çıkan: Üniversite çevreleri
              </p>
            </div>
            <div style={styles.analysisItem}>
              <h4 style={styles.analysisTitle}>İzmir Kiral Getiriler</h4>
              <p style={styles.analysisText}>
                Yıllık ortalama: %7-10<br />
                Popüler: Sahil bölgeleri
              </p>
            </div>
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Yapay Zeka Destekli Yatırım Danışmanı</h2>
          <div style={styles.aiSection}>
            <div style={styles.aiContent}>
              <h3 style={styles.aiTitle}>Kişiselleştirilmiş Yatırım Stratejisi</h3>
              <p style={styles.aiText}>
                Mobil uygulamamızdaki yapay zeka asistanımız, bütçenize, risk toleransınıza 
                ve yatırım hedeflerinize uygun kişiselleştirilmiş öneriler sunar.
              </p>
              <ul style={styles.aiFeatures}>
                <li style={styles.aiFeature}>Gerçek zamanlı piyasa analizi</li>
                <li style={styles.aiFeature}>Kişiye özel risk değerlendirmesi</li>
                <li style={styles.aiFeature}>Portföy optimizasyon önerileri</li>
                <li style={styles.aiFeature}>Getiri projeksiyonları</li>
              </ul>
            </div>
            <div style={styles.aiVisual}>
              <div style={styles.aiPlaceholder}>
                <p style={styles.aiPlaceholderText}>Yapay Zeka Analiz Arayüzü</p>
                <p style={styles.aiPlaceholderSubtext}>Mobil uygulamada aktif</p>
              </div>
            </div>
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Mobil Uygulama Özellikleri</h2>
          <div style={styles.appFeatures}>
            <div style={styles.appFeature}>
              <h4 style={styles.appFeatureTitle}>Detaylı Filtreleme</h4>
              <p style={styles.appFeatureText}>
                Şehir, ilçe, bütçe, daire tipi ve daha birçok kritere göre filtreleme
              </p>
            </div>
            <div style={styles.appFeature}>
              <h4 style={styles.appFeatureTitle}>Yapay Zeka ile Karşılaştırma</h4>
              <p style={styles.appFeatureText}>
                Yapay zeka ile ilçeleri karşılaştırabilir ve analiz edebilirsiniz
              </p>
            </div>
            <div style={styles.appFeature}>
              <h4 style={styles.appFeatureTitle}>Piyasa Haberleri</h4>
              <p style={styles.appFeatureText}>
                Anlık piyasa gelişmeleri ve uzman yorumları
              </p>
            </div>
          </div>
        </section>

        {/* YENİ EKLENEN BÖLÜMLER */}

        <section style={styles.section}>
          <h2 style={styles.heading}>Uzman Makaleleri</h2>
          <div style={styles.articlesSection}>
            <p style={styles.text}>
              Gayrimenkul yatırımları hakkında derinlemesine analizler ve uzman görüşleri 
              için makaleler sayfamızı ziyaret edin.
            </p>
            <div style={styles.articlesGrid}>
              <div style={styles.articleCard}>
                <h4 style={styles.articleTitle}>2024 Gayrimenkul Trendleri</h4>
                <p style={styles.articleText}>
                  Yeni yılda yatırımcıları neler bekliyor? Hangi bölgeler öne çıkacak?
                </p>
                <a href="/makaleler" style={styles.readMoreLink}>Devamını Oku →</a>
              </div>
              
              <div style={styles.articleCard}>
                <h4 style={styles.articleTitle}>Kripto vs Gayrimenkul</h4>
                <p style={styles.articleText}>
                  İki popüler yatırım aracının risk-getiri karşılaştırması
                </p>
                <a href="/makaleler" style={styles.readMoreLink}>Devamını Oku →</a>
              </div>
              
              <div style={styles.articleCard}>
                <h4 style={styles.articleTitle}>Yeşil Bina Yatırımları</h4>
                <p style={styles.articleText}>
                  Sürdürülebilir gayrimenkul yatırımlarının geleceği ve getirileri
                </p>
                <a href="/makaleler" style={styles.readMoreLink}>Devamını Oku →</a>
              </div>
            </div>
            <div style={styles.articlesCTA}>
              <a href="/makaleler" style={styles.articlesButton}>
                Tüm Makaleleri Görüntüle
              </a>
            </div>
          </div>
        </section>

        <section style={styles.section}>
          <div style={styles.sectionHeader}>
            <h2 style={styles.heading}>Müşterilerimizin Sorduğu Sorular</h2>
            <a href="/sorulan_sorular" style={styles.viewAllLink}>Tümünü Gör →</a>
          </div>
          <div style={styles.faqGrid}>
            <div style={styles.faqItem}>
              <h4 style={styles.faqQuestion}>Neden metrekare birim fiyatına bakmalıyım?</h4>
              <p style={styles.faqAnswer}>
                Evin toplam fiyatı benzer olsa bile metrekare boyutları değişebileceği için karşılaştırma yapmak zorlaşır. Metrekare birim fiyatı, hangi projenin daha avantajlı olduğunu anlamanızı sağlar.
              </p>
            </div>
            
            <div style={styles.faqItem}>
              <h4 style={styles.faqQuestion}>Net ve brüt metrekare arasındaki fark nedir?</h4>
              <p style={styles.faqAnswer}>
                Net metrekare: Dairenin gerçek kullanılabilir alanıdır (temiz alan). Brüt metrekare: Ortak alanlar dahil geniş hesaptır. Brüt alana nelerin dahil edildiğini mutlaka sözleşmede kontrol edin.
              </p>
            </div>
            
            <div style={styles.faqItem}>
              <h4 style={styles.faqQuestion}>Ödeme planında nelere dikkat edilmeli?</h4>
              <p style={styles.faqAnswer}>
                Taksitlerin düşük olması yanıltıcı olabilir. Ara ödeme tarihlerini ve miktarlarını kontrol edin, gelirinizle uyumlu olup olmadığını değerlendirin ve gerekirse plan değişikliği isteyin.
              </p>
            </div>
          </div>
        </section>

        <section style={styles.ctaSection}>
          <h2 style={styles.ctaTitle}>Yatırım Fırsatlarını Kaçırmayın!</h2>
          <p style={styles.ctaText}>
            Mobil uygulamamızı indirerek yapay zeka destekli yatırım danışmanımızdan 
            ücretsiz yararlanın ve akıllı yatırım kararları alın.
          </p>

          <div style={styles.ctaButtons}>
            <button 
              style={styles.ctaButton}
              onClick={handlePlayStoreClick}
            >
              Google Play'den İndir
            </button>

            <button 
              style={styles.ctaButton}
              onClick={handleAppStoreClick}
            >
              App Store'dan İndir
            </button>
          </div>
        </section>

        <section style={styles.disclaimer}>
          <p style={styles.disclaimerText}>
            <strong>Önemli Not:</strong> Bu sitede yer alan bilgiler yatırım tavsiyesi değildir. 
            Yatırım kararlarınızı vermeden önce uzman danışmanlardan görüş alınız.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Yatirim;
